module.exports = {
  "revenuestagechangesubmit": {
    "name": "revenuestagechangesubmit",
    "class": "usage",
    "properties": {
      "stageName": "string"
    },
    "namespace": "customer-data-properties",
    "version": "1"
  },
  "Interaction": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "action": {
        "type": "string"
      },
      "propertyName": {
        "type": "string",
        "isOptional": true
      },
      "objectTypeId": {
        "type": "string",
        "isOptional": true
      },
      "type": {
        "type": "string",
        "isOptional": true
      },
      "propertyNames": {
        "type": "array",
        "isOptional": true
      }
    },
    "namespace": "customer-data-properties",
    "version": "1"
  },
  "Pageview": {
    "name": "Pageview",
    "class": "view",
    "properties": {
      "screen": "string"
    },
    "namespace": "customer-data-properties",
    "version": "1"
  }
};